<template>
  <div class="columns is-gapless is-vcentered is-margin-bottom">
    <div class="column is-6">

      <div class="field has-addons">
        <div class="control w100p has-bg-lighter is-border columns is-vcentered is-padding-left-xsmall is-square">
          <b>{{currentItem.unit | prettyUnit}}</b>
        </div>
        <div class="control w70p has-incrementations" v-if="!currentItem.terminated && !isTerminated">
          <input class="input" :class="{'is-border': !edit}"
                type="number" placeholder="" v-model="currentItem.amount"
                @focus="selectInput('inputfact')" ref="inputfact"
                :max="currentItem.unit === 'percent' ? 100 : ''" @input="edit = true">
          <div class="incrementation">
            <a href="#" @click="incrementUp()" class="incrementation-btn"><i class="fas fa-chevron-up"></i></a>
            <a href="#" @click="incrementDown()" class="incrementation-btn"><i class="fas fa-chevron-down"></i></a>
          </div>
        </div>
        <div v-else class="control w80p has-bg-light is-border columns is-vcentered is-padding-left-small">
          <span>{{currentItem.amount}} {{currentItem.unit | prettySymbol}}</span>
        </div>
        <div class="control">
          <a class="button is-min-width-0 is-border is-static is-square">
            <span class="icon">
              <i v-if="currentItem.terminated" class="fas fa-lock"></i>
              <i v-else-if="currentItem.unit === 'percent'" class="fas fa-percentage"></i>
              <i v-else-if="currentItem.unit === 'currency'" :class="`fas fa-${$faCurrency}-sign`"></i>
            </span>
          </a>
        </div>
        <div class="control" v-if="edit">
          <a class="button is-square is-success is-border is-min-width-0 has-hover-black" @click="updateItem">
            <span class="icon"><i class="fas fa-save"></i></span>
          </a>
        </div>
        <div class="control" v-if="edit">
          <a class="button is-square is-light is-border is-min-width-0" @click="cancelEditItem">
            <span class="icon"><i class="fas fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <div class="column is-2 has-text-primary has-text-right">
      <div class="is-size-4 has-text-weight-medium">{{currentItem.total_ht.toFixed(2)}} {{$currency}} HT</div>
      <div class="">{{currentItem.total_ttc.toFixed(2)}} {{$currency}} TTC</div>
    </div>
    <div class="column is-narrow is-padding-left" v-if="!edit">
      <div class="field is-grouped" v-if="!hasAskDelete && !hasAskFinish">
        <div v-if="canEditBill && billDownloadLink && currentItem.amount > 0 && isCurrencyEur" class="control">
          <a @click="openModal"
             class="button is-small is-white is-border is-circle">
            <span class="icon is-small"><i class="fas fa-file-pdf is-size-5"></i></span>
          </a>
        </div>
        <div class="control" v-if="!currentItem.terminated && !isTerminated">
          <a @click="askDelete" class="button is-small is-white is-border is-circle">
            <span class="icon is-small"><i class="fas fa-trash is-size-5"></i></span>
          </a>
        </div>
        <div class="control" v-if="isDeposit && !currentItem.terminated && !isTerminated && !currentIsInternal && currentItem.amount > 0 && isCurrencyEur">
          <a @click="askFinish" class="button is-small is-success is-rounded is-transform-none">
            <span class="is-small"><i class="fas fa-lock-alt is-size-5"></i></span>
            <span class="has-text-weight-bold is-padding-left-xsmall">Finaliser facture*</span>
          </a>
        </div>
        <div class="control" v-if="isDeposit && currentItem.terminated && !currentItem.sending_date && !isTerminated && isCurrencyEur">
          <a @click="sendBill" class="button is-small is-white is-rounded is-transform-none is-border">
            <span class="is-small"><i class="fas fa-check is-size-5"></i></span>
            <span class="has-text-weight-bold is-padding-left-xsmall">Valider envoi</span>
          </a>
        </div>
        <div class="control" v-if="isDeposit && currentItem.sending_date">
          <div class="tag is-medium is-success is-radius-large">
            <span class="icon is-small is-size-6"><i class="fas fa-envelope"></i></span><span class="is-size-6">Envoyé le {{currentItem.sending_date | date}}</span>
          </div>
        </div>
      </div>
      <div class="field is-grouped" v-else>
        <div class="control" v-if="hasAskDelete">
          <a @click="confirmDelete" class="button is-small is-danger is-rounded">
            <span>Confirmer suppression</span>
          </a>
        </div>
        <div class="control" v-if="hasAskFinish">
          <a @click="confirmFinish" class="button is-small is-danger is-rounded">
            <span>Confirmer finalisation</span>
          </a>
        </div>
        <div class="control" v-if="currentItem.amount > 0">
          <a @click="cancelAsk" class="button is-small is-white is-border is-circle ">
            <span class="icon is-small">
              <i class="fas fa-times is-size-5"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce, cloneDeep } from 'lodash'

  export default {
    name: 'FacturationItem',
    data () {
      return {
        hasAskDelete: false,
        hasAskFinish: false,
        currentItem: null,
        edit: false,
        savedItem: null,
        countEdit: 0
      }
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      index: Number,
      parent: String,
      tva: {
        type: Number,
        default: 20
      },
      billDownloadLink: {
        type: String,
        required: false
      },
      canEditBill: {
        type: Boolean,
        required: false,
        default: false
      },
      isTerminated: {
        type: Boolean,
        default: false
      },
      currentIsInternal: {
        type: Boolean,
        default: false
      },
      companyDataError: {
        type: String,
        default: null
      }
    },
    filters: {
      prettyUnit (unit) {
        if (unit === 'percent') return 'Pourcentage'
        else return 'Montant'
      },
      prettySymbol (unit) {
        if (unit === 'percent') return '%'
        else return this.$currency
      }
    },
    computed: {
      isCurrencyEur () {
        if (!this.$configs) return
        return this.$configs.CURRENCY === 'EUR'
      },
      isDeposit () {
        return this.parent === 'deposits'
      },
      incrementationsPas () {
        if (this.currentItem.unit === 'percent') {
          return 0.1
        } else {
          return 50
        }
      }
    },
    watch: {
      item (v) {
        this.currentItem = v
        this.savedItem = cloneDeep(v)
      },
      edit (v) {
        this.$emit('pendingEdit', v)
      }
    },
    methods: {
      openModal () {
        let params = {
          linkEmbed: this.billDownloadLink
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
      },
      updateItem: debounce(function () {
        this.edit = false
        this.$emit('update', {item: this.currentItem, index: this.index, parent: this.parent})
        this.$emit('askFinish', false)
      }, 500),
      cancelEditItem () {
        this.edit = false
        this.currentItem = cloneDeep(this.savedItem)
      },
      askDelete () {
        this.hasAskDelete = true
      },
      askFinish () {
        this.$emit('askFinish', true)
        if (this.companyDataError) return
        this.hasAskFinish = true
      },
      cancelAsk () {
        this.$emit('askFinish', false)
        this.hasAskDelete = false
        this.hasAskFinish = false
      },
      confirmDelete () {
        this.$emit('delete', {index: this.index, parent: this.parent})
      },
      confirmFinish () {
        this.currentItem.terminated = true
        this.hasAskFinish = false
        this.updateItem()
      },
      sendBill () {
        this.$emit('sendBill', {item: this.currentItem, index: this.index})
      },
      selectInput (input) {
        if (input in this.$refs) {
          if (Array.isArray(this.$refs[input])) {
            this.$refs[input][0].select()
          } else {
            this.$refs[input].select()
          }
        }
      },
      incrementUp () {
        this.currentItem.amount = Math.round((this.currentItem.amount + this.incrementationsPas) * 10) / 10
        this.edit = true
      },
      incrementDown () {
        this.currentItem.amount = Math.round((this.currentItem.amount - this.incrementationsPas) * 10) / 10
        this.edit = true
      }
    },
    created () {
      if (this.item) {
        this.currentItem = this.item
        this.savedItem = cloneDeep(this.item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Commercialisation/FacturationItem.vue